const legalDocumentTranslations = {
  en: {
    navigation: "Legal documents",
    title: "Legal Documents & Deal Protection",
    subtitle: "Controlled legal records, mandates and commission protection.",
    back: "Back to opportunities",
    create: "Create legal document",
    total: "Total documents",
    pendingReview: "Pending legal review",
    approved: "Approved",
    signed: "Signed originals",
    loading: "Loading legal documents…",
    noDocuments: "No legal documents have been created for this opportunity.",
    parties: "Document parties",
    noParties: "Add the deal parties before submitting a document for approval.",
    legalNotice: "Internal draft-management tool. Documents are not legal advice and must be reviewed by a qualified professional before use or signature.",
    cancel: "Cancel",
    save: "Save document",
    saving: "Saving…",
    created: "Legal document created",
    actionFailed: "The action could not be completed",
    none: "None",
    version: "Version",
    legalReview: "Legal review",
    confidential: "Confidential",
    fileRecorded: "Controlled document file recorded",
    noFile: "No document version uploaded",
    fields: {
      title: "Document title",
      documentType: "Document type",
      legalFramework: "Legal framework",
      language: "Primary language",
      secondaryLanguage: "Secondary language",
      governingLaw: "Governing law",
      jurisdiction: "Jurisdiction",
    },
    languages: {
      en: "English", pt: "Portuguese", zh: "Chinese", fr: "French",
      es: "Spanish", de: "German", it: "Italian", ru: "Russian",
    },
  },
  pt: {
    navigation: "Documentos jurídicos",
    title: "Documentos Jurídicos e Proteção do Negócio",
    subtitle: "Registos jurídicos controlados, mandatos e proteção de comissões.",
    back: "Voltar às oportunidades",
    create: "Criar documento jurídico",
    total: "Total de documentos",
    pendingReview: "A aguardar revisão jurídica",
    approved: "Aprovados",
    signed: "Originais assinados",
    loading: "A carregar documentos jurídicos…",
    noDocuments: "Ainda não foram criados documentos jurídicos para esta oportunidade.",
    parties: "Partes do documento",
    noParties: "Adicione as partes do negócio antes de submeter o documento para aprovação.",
    legalNotice: "Ferramenta interna de gestão de minutas. Os documentos não constituem aconselhamento jurídico e devem ser revistos por um profissional qualificado antes da utilização ou assinatura.",
    cancel: "Cancelar",
    save: "Guardar documento",
    saving: "A guardar…",
    created: "Documento jurídico criado",
    actionFailed: "Não foi possível concluir a ação",
    none: "Nenhum",
    version: "Versão",
    legalReview: "Revisão jurídica",
    confidential: "Confidencial",
    fileRecorded: "Ficheiro controlado registado",
    noFile: "Nenhuma versão carregada",
    fields: {
      title: "Título do documento",
      documentType: "Tipo de documento",
      legalFramework: "Enquadramento jurídico",
      language: "Idioma principal",
      secondaryLanguage: "Idioma secundário",
      governingLaw: "Lei aplicável",
      jurisdiction: "Jurisdição",
    },
    languages: {
      en: "Inglês", pt: "Português", zh: "Chinês", fr: "Francês",
      es: "Espanhol", de: "Alemão", it: "Italiano", ru: "Russo",
    },
  },
  zh: {
    navigation: "法律文件",
    title: "法律文件与交易保护",
    subtitle: "受控法律记录、授权委托与佣金保护。",
    back: "返回投资机会",
    create: "创建法律文件",
    total: "文件总数",
    pendingReview: "等待法律审查",
    approved: "已批准",
    signed: "已签署正本",
    loading: "正在加载法律文件…",
    noDocuments: "此投资机会尚未创建法律文件。",
    parties: "文件当事方",
    noParties: "请先添加交易当事方，再提交文件审批。",
    legalNotice: "本工具仅用于内部草案管理，不构成法律意见。所有文件在使用或签署前必须由合资格专业人士审查。",
    cancel: "取消",
    save: "保存文件",
    saving: "正在保存…",
    created: "法律文件已创建",
    actionFailed: "无法完成操作",
    none: "无",
    version: "版本",
    legalReview: "法律审查",
    confidential: "机密",
    fileRecorded: "受控文件已登记",
    noFile: "尚未上传文件版本",
    fields: {
      title: "文件标题",
      documentType: "文件类型",
      legalFramework: "法律框架",
      language: "主要语言",
      secondaryLanguage: "第二语言",
      governingLaw: "适用法律",
      jurisdiction: "司法管辖区",
    },
    languages: {
      en: "英语", pt: "葡萄牙语", zh: "中文", fr: "法语",
      es: "西班牙语", de: "德语", it: "意大利语", ru: "俄语",
    },
  },
  fr: {
    navigation: "Documents juridiques",
    title: "Documents Juridiques et Protection de l’Opération",
    subtitle: "Dossiers juridiques contrôlés, mandats et protection des commissions.",
    back: "Retour aux opportunités",
    create: "Créer un document juridique",
    total: "Total des documents",
    pendingReview: "En attente de révision juridique",
    approved: "Approuvés",
    signed: "Originaux signés",
    loading: "Chargement des documents juridiques…",
    noDocuments: "Aucun document juridique n’a été créé pour cette opportunité.",
    parties: "Parties au document",
    noParties: "Ajoutez les parties à l’opération avant de soumettre le document à approbation.",
    legalNotice: "Outil interne de gestion des projets. Les documents ne constituent pas un conseil juridique et doivent être examinés par un professionnel qualifié avant utilisation ou signature.",
    cancel: "Annuler",
    save: "Enregistrer le document",
    saving: "Enregistrement…",
    created: "Document juridique créé",
    actionFailed: "L’action n’a pas pu être effectuée",
    none: "Aucun",
    version: "Version",
    legalReview: "Révision juridique",
    confidential: "Confidentiel",
    fileRecorded: "Fichier contrôlé enregistré",
    noFile: "Aucune version téléversée",
    fields: {
      title: "Titre du document",
      documentType: "Type de document",
      legalFramework: "Cadre juridique",
      language: "Langue principale",
      secondaryLanguage: "Langue secondaire",
      governingLaw: "Droit applicable",
      jurisdiction: "Juridiction",
    },
    languages: {
      en: "Anglais", pt: "Portugais", zh: "Chinois", fr: "Français",
      es: "Espagnol", de: "Allemand", it: "Italien", ru: "Russe",
    },
  },
  es: {
    navigation: "Documentos jurídicos",
    title: "Documentos Jurídicos y Protección de la Operación",
    subtitle: "Registros jurídicos controlados, mandatos y protección de comisiones.",
    back: "Volver a oportunidades",
    create: "Crear documento jurídico",
    total: "Total de documentos",
    pendingReview: "Pendientes de revisión jurídica",
    approved: "Aprobados",
    signed: "Originales firmados",
    loading: "Cargando documentos jurídicos…",
    noDocuments: "No se han creado documentos jurídicos para esta oportunidad.",
    parties: "Partes del documento",
    noParties: "Añada las partes de la operación antes de someter el documento a aprobación.",
    legalNotice: "Herramienta interna de gestión de borradores. Los documentos no constituyen asesoramiento jurídico y deben ser revisados por un profesional cualificado antes de su uso o firma.",
    cancel: "Cancelar",
    save: "Guardar documento",
    saving: "Guardando…",
    created: "Documento jurídico creado",
    actionFailed: "No se pudo completar la acción",
    none: "Ninguno",
    version: "Versión",
    legalReview: "Revisión jurídica",
    confidential: "Confidencial",
    fileRecorded: "Archivo controlado registrado",
    noFile: "No se ha cargado ninguna versión",
    fields: {
      title: "Título del documento",
      documentType: "Tipo de documento",
      legalFramework: "Marco jurídico",
      language: "Idioma principal",
      secondaryLanguage: "Idioma secundario",
      governingLaw: "Ley aplicable",
      jurisdiction: "Jurisdicción",
    },
    languages: {
      en: "Inglés", pt: "Portugués", zh: "Chino", fr: "Francés",
      es: "Español", de: "Alemán", it: "Italiano", ru: "Ruso",
    },
  },
  de: {
    navigation: "Rechtsdokumente",
    title: "Rechtsdokumente und Transaktionsschutz",
    subtitle: "Kontrollierte Rechtsakten, Mandate und Provisionsschutz.",
    back: "Zurück zu den Chancen",
    create: "Rechtsdokument erstellen",
    total: "Dokumente insgesamt",
    pendingReview: "Rechtliche Prüfung ausstehend",
    approved: "Genehmigt",
    signed: "Unterzeichnete Originale",
    loading: "Rechtsdokumente werden geladen…",
    noDocuments: "Für diese Gelegenheit wurden noch keine Rechtsdokumente erstellt.",
    parties: "Dokumentparteien",
    noParties: "Fügen Sie die Transaktionsparteien hinzu, bevor Sie das Dokument zur Genehmigung einreichen.",
    legalNotice: "Internes Werkzeug zur Entwurfsverwaltung. Die Dokumente stellen keine Rechtsberatung dar und müssen vor Verwendung oder Unterzeichnung von einer qualifizierten Fachperson geprüft werden.",
    cancel: "Abbrechen",
    save: "Dokument speichern",
    saving: "Speichern…",
    created: "Rechtsdokument erstellt",
    actionFailed: "Die Aktion konnte nicht abgeschlossen werden",
    none: "Keine",
    version: "Version",
    legalReview: "Rechtliche Prüfung",
    confidential: "Vertraulich",
    fileRecorded: "Kontrollierte Datei registriert",
    noFile: "Keine Version hochgeladen",
    fields: {
      title: "Dokumenttitel",
      documentType: "Dokumenttyp",
      legalFramework: "Rechtsrahmen",
      language: "Hauptsprache",
      secondaryLanguage: "Zweitsprache",
      governingLaw: "Anwendbares Recht",
      jurisdiction: "Gerichtsstand",
    },
    languages: {
      en: "Englisch", pt: "Portugiesisch", zh: "Chinesisch", fr: "Französisch",
      es: "Spanisch", de: "Deutsch", it: "Italienisch", ru: "Russisch",
    },
  },
  it: {
    navigation: "Documenti legali",
    title: "Documenti Legali e Protezione dell’Operazione",
    subtitle: "Registri legali controllati, mandati e protezione delle commissioni.",
    back: "Torna alle opportunità",
    create: "Crea documento legale",
    total: "Documenti totali",
    pendingReview: "In attesa di revisione legale",
    approved: "Approvati",
    signed: "Originali firmati",
    loading: "Caricamento dei documenti legali…",
    noDocuments: "Non sono stati creati documenti legali per questa opportunità.",
    parties: "Parti del documento",
    noParties: "Aggiungere le parti dell’operazione prima di sottoporre il documento all’approvazione.",
    legalNotice: "Strumento interno di gestione delle bozze. I documenti non costituiscono consulenza legale e devono essere revisionati da un professionista qualificato prima dell’uso o della firma.",
    cancel: "Annulla",
    save: "Salva documento",
    saving: "Salvataggio…",
    created: "Documento legale creato",
    actionFailed: "Impossibile completare l’azione",
    none: "Nessuno",
    version: "Versione",
    legalReview: "Revisione legale",
    confidential: "Riservato",
    fileRecorded: "File controllato registrato",
    noFile: "Nessuna versione caricata",
    fields: {
      title: "Titolo del documento",
      documentType: "Tipo di documento",
      legalFramework: "Quadro giuridico",
      language: "Lingua principale",
      secondaryLanguage: "Lingua secondaria",
      governingLaw: "Legge applicabile",
      jurisdiction: "Giurisdizione",
    },
    languages: {
      en: "Inglese", pt: "Portoghese", zh: "Cinese", fr: "Francese",
      es: "Spagnolo", de: "Tedesco", it: "Italiano", ru: "Russo",
    },
  },
  ru: {
    navigation: "Юридические документы",
    title: "Юридические Документы и Защита Сделки",
    subtitle: "Контролируемые юридические записи, поручения и защита комиссии.",
    back: "Вернуться к возможностям",
    create: "Создать юридический документ",
    total: "Всего документов",
    pendingReview: "Ожидают юридической проверки",
    approved: "Одобрены",
    signed: "Подписанные оригиналы",
    loading: "Загрузка юридических документов…",
    noDocuments: "Для этой возможности юридические документы ещё не созданы.",
    parties: "Стороны документа",
    noParties: "Добавьте стороны сделки до направления документа на утверждение.",
    legalNotice: "Внутренний инструмент управления проектами документов. Документы не являются юридической консультацией и должны быть проверены квалифицированным специалистом до использования или подписания.",
    cancel: "Отмена",
    save: "Сохранить документ",
    saving: "Сохранение…",
    created: "Юридический документ создан",
    actionFailed: "Не удалось выполнить действие",
    none: "Нет",
    version: "Версия",
    legalReview: "Юридическая проверка",
    confidential: "Конфиденциально",
    fileRecorded: "Контролируемый файл зарегистрирован",
    noFile: "Версия документа не загружена",
    fields: {
      title: "Название документа",
      documentType: "Тип документа",
      legalFramework: "Правовая основа",
      language: "Основной язык",
      secondaryLanguage: "Второй язык",
      governingLaw: "Применимое право",
      jurisdiction: "Юрисдикция",
    },
    languages: {
      en: "Английский", pt: "Португальский", zh: "Китайский", fr: "Французский",
      es: "Испанский", de: "Немецкий", it: "Итальянский", ru: "Русский",
    },
  },
};

export default legalDocumentTranslations;
